module.exports = __webpack_public_path__ + "img/28ne.1b6eec32.svg";